import React, { Component } from "react";
import InfiniteScroll from 'react-infinite-scroller';
import qwest from 'qwest';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <h1>Our Community</h1>
        <UserList />
      </div>
    )

  }
}

export default App;

var baseUrl = "https://randomuser.me/api?results=10&seed=hi&page="; //&page=0

class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      hasMoreItems: true,
      nextHref: null,
      page: 1
    };
  }

  loadItems(page) {
    var self = this;
    var url = "https://randomuser.me/api?results=10&seed=hi&page=0";
    if (self.state.nextHref) {
      url = self.state.nextHref;
    }

    qwest.get(url)
      .then(function(xhr, resp) {
        console.log(resp);
        if (resp) {
          var users = self.state.users;
          resp.results.map((user) => {
            users.push(user);
          });
          self.setState({
            users: users,
            nextHref: baseUrl + (self.state.page + 1),
            page: self.state.page + 1
          })

        }
      });
  }

  render() {
    const loader = <div className="loader">Loading ...</div>;

    var items = [];
    this.state.users.map((user, i) => {
      items.push(
        <div className="user" key={ i }>
          <img src={ user.picture.large } alt="" />
          <p className="name">
            { user.name.first }<span> </span>
            { user.name.last }
          </p>
        </div>
      );
    });
    return (
      <InfiniteScroll pageStart={ 0 } loadMore={ this.loadItems.bind(this) } hasMore={ this.state.hasMoreItems } loader={ loader }>
        <div className="">
          <div className="users mx-auto">
            { items }
          </div>
        </div>
      </InfiniteScroll>
      );
  }



}



// WEBPACK FOOTER //
// ./src/App.js